module.exports = __webpack_public_path__ + "img/logo_square_the_lorry.e3656734.png";